import Voucher from '../../../../components/Voucher';

const LoyaltyVoucher = (props) => {
	const { loyaltyVoucherList, remainingNominal, handleVoucherDetail, setDataVoucherWarning, setIsShowWarningVoucher, handleUpdateVoucherList } = props;
	return (
		<>
			{loyaltyVoucherList?.map((v, index) => {
				const voucher = {
					image: v?.imageUrl,
					name: v?.name,
					nominal_voucher: v?.nominal,
          expired_date: v?.expiredAt,
          ...v,
				};
				return (
					<Voucher
						key={`loyalty_voucher_${index}`}
						type={'loyalty_voucher'}
						data={voucher}
						handleUseVoucher={(data, type, warning) => {
							if (warning && type === "plus") {
								setDataVoucherWarning({
									code: data.id,
									voucher_type: 'loyalty_voucher',
									is_use: data.is_use ?? false,
									type: type,
								});
								setIsShowWarningVoucher(true);
							} else {
								handleUpdateVoucherList(data.id, 'loyalty_voucher', data.is_use ?? false, type);
							}
						}}
						remainingNominal={remainingNominal}
						onOpenDetail={() => handleVoucherDetail(true, voucher)}
					/>
				);
			})}
		</>
	);
};

export default LoyaltyVoucher;
